angular.module('cfn').factory('cfnGridFnHacks', function() {
  var service = {};
  service.init = function(scope, element, attrs) {
    var serviceInstance = {};
    serviceInstance.updateVarietyFilters = function() {
      if (!scope.ngModel) {
        // Data not ready
        return;
      }

      scope.view.filterArrays = scope.view.filterArrays || {};

      $.each(scope.columns, function(i, col) {
        if (col.filterSelector === 'VarietySelector') {
          // Find out all different values in our model
          var varieties = {},
            varietyArray = [];
          // Find out distinct/unique values
          $.each(scope.ngModel, function(i, modelRow) {
            var value = modelRow[col.name];
            if (value) {
              varieties[value] = true;
            }
          });
          $.each(varieties, function(year) {
            varietyArray.push(year);
          });

          scope.view.filterArrays[col.name] = varietyArray;
        }
      });
    };
    serviceInstance.afterUpdateModel = function() {
      serviceInstance.updateVarietyFilters();
    };
    return serviceInstance;
  };

  return service;
});
